export const INFO_DIALOG_WIDTH = 343;
